import { Controller } from "@hotwired/stimulus"

// Timesheets → Receipts (Kloepfer K3-41): Verify a receipt sent from the
// phone, or Undo it back to Pending. Only that row redraws (from the
// server's answer), the summary line follows, and a toast says it's done.
export default class extends Controller {
  static targets = ["summary"]
  static values = { verifyUrl: String, unverifyUrl: String, error: String }

  verify(event) {
    this._decide(event, this.verifyUrlValue)
  }

  unverify(event) {
    this._decide(event, this.unverifyUrlValue)
  }

  async _decide(event, urlTemplate) {
    const button = event.currentTarget
    const row = button.closest("[data-receipt-id]")
    if (!row) return
    button.disabled = true
    try {
      const res = await fetch(urlTemplate.replace("__ID__", encodeURIComponent(row.dataset.receiptId)), {
        method: "POST",
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || ""
        }
      })
      const data = await res.json().catch(() => ({}))
      if (!res.ok || !data.row_html) {
        button.disabled = false
        this._showToast(data.error || this.errorValue, "error")
        return
      }
      row.outerHTML = data.row_html
      if (data.summary && this.hasSummaryTarget) this.summaryTarget.textContent = data.summary
      this._showToast(data.message, "success")
    } catch (_e) {
      button.disabled = false
      this._showToast(this.errorValue, "error")
    }
  }

  _showToast(message, type = "success") {
    if (!message) return
    const cssType = type === "error" ? "alert" : "notice"
    const icon = cssType === "notice"
      ? '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/></svg>'
      : '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5"><path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"/></svg>'
    const el = document.createElement("div")
    el.className = `flash-toast-${cssType}`
    el.setAttribute("data-controller", "flash")
    el.setAttribute("data-flash-dismiss-after-value", "5000")
    el.setAttribute("role", "alert")
    const iconDiv = document.createElement("div")
    iconDiv.className = "shrink-0"
    iconDiv.innerHTML = icon
    const msg = document.createElement("p")
    msg.className = "flex-1 text-sm"
    msg.textContent = message
    el.appendChild(iconDiv)
    el.appendChild(msg)
    document.body.prepend(el)
  }
}
